export const FETCHING = "FETCHING"
export const ERROR = "ERROR"
export const IDLE = "IDLE"
export const PREPARING = 'PREPARING'
export const WAITING = 'WAITING'
export const READY = 'READY'